// Imports
import React, { useContext, useEffect } from 'react';
import APIConnectedFormContext, { ContextDetails } from '../../../../../../../shareables/contexts/api-connected-form';
import File, {
	SingleFileProps,
} from '../../../../../../../shareables/foundation/front-end/components/forms/fields/file';


// Define the accepted props
interface BaseProps {
	parentParameter?: string;
}

type CompleteProps = SingleFileProps & BaseProps;


// Function component
const PhotoUpload = React.forwardRef<HTMLInputElement, CompleteProps>(({ onChange, ...props }: CompleteProps, ref) => {
	// Break off the props we don't want to give to the intrinsic element
	const { parentParameter, ...passThroughProps } = props;
	
	
	// Use context
	const context = useContext(APIConnectedFormContext);
	
	
	// Initialize name
	const fieldName = parentParameter ? `${parentParameter}.profilePhoto` : 'profilePhoto';
	
	
	// Retrieve error from API form's context, set error state if it matches
	const errorMessage = context?.error.field === fieldName ? context.error.message : undefined;
	
	
	// Add and remove error container from form
	let addErrorContainer: NonNullable<ContextDetails>['addErrorContainer'] | null = null;
	let removeErrorContainer: NonNullable<ContextDetails>['removeErrorContainer'] | null = null;
	
	if (context) {
		addErrorContainer = context.addErrorContainer;
		removeErrorContainer = context.removeErrorContainer;
	}
	
	useEffect(() => {
		if (!addErrorContainer) {
			return;
		}
		
		addErrorContainer(fieldName);
		
		return () => {
			if (!removeErrorContainer) {
				return;
			}
			
			removeErrorContainer(fieldName);
		};
	}, [addErrorContainer, removeErrorContainer, fieldName]);
	
	
	// Handle change
	const handleChange: SingleFileProps['onChange'] = (file) => {
		onChange?.(file);
		context?.clearErrors(fieldName);
	};
	
	
	// Return JSX
	return <File errorMessage={errorMessage ?? undefined} onChange={handleChange} {...passThroughProps} ref={ref} />;
});


// @ts-expect-error: displayName does exist
PhotoUpload.displayName = 'PhotoUpload';

export default PhotoUpload;
